import { DropDown } from '@components/core-ui/form-elements/DropDown';
import Dots from '@components/icons/Dots.svg';
import { useModalContext } from '@providers/ModalProvider';
import { GetBillingAccountResponseDto } from 'app/API';
import { TPaymentMethod } from 'app/types/entities/TPaymentMethod';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useState } from 'react';
import { TextButtonLarge } from '@components/core-ui/form-elements/buttons/Button/variations/TextButtonLarge';
import { Wrapper } from './styles/Wrapper';
import { DotsButton } from '@pages/User/BillingAccountDetailsPage/components/SubscriptionsWrapper/Cards/ActiveCard/styles/DotsButton';

type TProps = {
  className?: string;
  method?: TPaymentMethod;
  billingAccount?: GetBillingAccountResponseDto;
  reloadCards: () => void;
  canManageBillingAccount: boolean;
};

export const PaymentMethodCard = ({
  className = '',
  method,
  billingAccount,
  canManageBillingAccount,
  reloadCards,
}: TProps) => {
  const { openModal, closeModal } = useModalContext();
  const [showDropDown, setShowDropDown] = useState(false);

  const onAddNewPaymentMethod = (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
    e.stopPropagation();
    if (!canManageBillingAccount) {
      return;
    }
    openModal(ModalNamesEnum.AddPaymentMethod, {
      billingAccountId: billingAccount?.id,
      onSuccess: () => {
        closeModal();
        reloadCards();
      },
    });
  };

  const onShowPaymentHistory = () => {
    openModal(ModalNamesEnum.PaymentMethodsHistory, {
      billingAccountId: billingAccount?.id,
      onCancel: () => {
        closeModal();
        reloadCards();
      },
    });
  };

  let description = <div className="card empty">Not set</div>;
  if (method) {
    description = (
      <div className="card">
        <span>Card</span>
        **** {method.last4}
      </div>
    );
  }

  const renderOptions = () => {
    const dropDownOptions: {
      title: string;
      onClick: (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => void;
    }[] = [];
    if (canManageBillingAccount) {
      dropDownOptions.push({
        title: 'History',
        onClick: onShowPaymentHistory,
      });
      dropDownOptions.push({
        title: 'Add New Method',
        onClick: onAddNewPaymentMethod,
      });
    }
    if (!dropDownOptions.length) {
      return;
    }
    return (
      <>
        <DotsButton
          className="dots-button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setShowDropDown(true);
          }}
        >
          <Dots />
        </DotsButton>
        {showDropDown ? <DropDown close={() => setShowDropDown(false)} options={dropDownOptions} /> : null}
      </>
    );
  };

  return (
    <Wrapper className={className}>
      <div className="content">
        <h2 className="title">Payment Method</h2>
        {renderOptions()}
      </div>

      <div className="description">{description}</div>

      {canManageBillingAccount ? (
        <div className="buttonContainer">
          <TextButtonLarge onClick={onAddNewPaymentMethod}>Add New Method</TextButtonLarge>
        </div>
      ) : null}
    </Wrapper>
  );
};
